<template>
  <div class="news-details-list-item border">
    <!-- <div class="read m-r-40"></div> -->
    <div class="f-colmun f-1">
      <div class="font-sm gray-font p-t-25 p-b-25 m-b-25 border w-100b">{{time}}</div>
      <div v-if="title" class="w-100b font-lg ellipsis title textarea-content">{{title}}</div>
      <div
        v-if="content"
        class="content darkgray-font m-t-15 m-b-20 ellipsis-3 w-100b textarea-content"
      >{{content}}</div>
      <div v-if="needUpload" class="upload-btn m-b-20" @click="toSelectFile">{{lawyerName}}律师邀请您上传附件</div>
      <img class="fileImage m-r-30" v-for="(item,index) in file" :key="index" :src="item" />
    </div>
  </div>
</template>

<script>
import { ref, reactive, onBeforeMount } from 'vue'
import router from '@/router'
import { getUrlQuery, isUrl } from '@/utils/url.js'
import { fileApi } from '@/apis'

export default {
  props: {
    title: String,
    time: String,
    content: String,
    lawyerName: String,
    needUpload: Boolean,
    file: Array,
    processNodeTblId: Number,
    tblId: Number,
  },
  setup(props, { emit }) {
    const toSelectFile = () => {
      router.push({
        path: '/selectFile',
        query: {
          tblId: props.tblId,
          processNodeTblId: props.processNodeTblId,
        },
      })
    }
    return { toSelectFile }
  },
}
</script>

<style lang="scss">
.news-details-list-item {
  display: flex;
  align-items: start;
  justify-content: start;
  padding: 20px 27px 30px 27px;
  background-color: #fff;
  .read {
    margin-top: 30px;
  }
  .title {
    width: 400px;
  }
  .fileImage {
    width: 82px;
    height: 82px;
  }
  .upload-btn {
    display: flex;
    align-items: center;
    height: 103px;
    background: #f4f6f9;
    padding-left: 35px;
    border-radius: 14px;
    color: #3370ff;
    font-size: 30px;
  }
}
</style>